<template>
  <v-container fluid>
    <v-row>
      <v-col cols="2">
        <salesman-combo
          v-model="query.salesman"
          label="業務員姓名"
          :rules="[
            (v) => !(v === null || v.name == '') || '請選擇/輸入業務員名稱',
          ]"
          required
        >
        </salesman-combo>
      </v-col>
      <v-col cols="6">
        <v-select
          :items="years"
          v-model="query.years"
          label="銷售年度"
          multiple
          required
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-btn color="primary" small class="mr-2" @click="displayChart">
          查詢
        </v-btn>
      </v-col>
    </v-row>
    <p>{{ message }}</p>
    <v-row>
      <v-col>
        <highcharts :options="getChartOptions"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
//定義介面元件
import SalesmanCombo from "../../components/SalesmanCombo";

import ChartDataService from "../../services/ChartDataService";

export default {
  components: {
    SalesmanCombo,
  },
  data() {
    return {
      query: {
        years: [],
        salesman: null,
      },
      chartOptions: null,
      series: [], //資料，區分出業務員各月份的銷售資料: {name:<<year>>, data:[01,02,03,04,05,06,07,08,09,10,11,12]}
      //categories: [], //類別，產品資料
      message: "",
      chart_title: "",
      chart_sub_title: "",
      years: [
        2025,
        2024,
        2023,
        2022,
        2021,
        2020,
        2019,
        2018,
        2017,
        2016,
        2015,
        2014,
        2013,
        2012,
        2011,
        2010,
      ],
    };
  },
  computed: {
    getChartOptions() {
      return {
        chart: {
          height: (9 / 16) * 100 - 25 + "%",
        },
        title: {
          text: this.chart_title,
          style: {
            fontSize: "24px",
          },
        },
        subtitle: {
          text: this.chart_sub_title,
          style: {
            fontSize: "20px",
          },
        },
        yAxis: {
          title: {
            text: "銷售金額",
            style: {
              fontSize: "15px",
            },
          },
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          itemStyle: {
            font: "16pt Trebuchet MS, Verdana, sans-serif",
          },
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
            pointStart: 1,
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: this.series,
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    displayChart() {
      if (this.query.salesman === null || this.query.years.length == 0) {
        this.message = "請選擇業務員，並選擇年度";
      } else {
        console.log(this.query.salesman, "salesman");
        ChartDataService.getSalesmanAnalysisData(
          this.query.salesman.id,
          this.query.years
        )
          .then((result) => {
            this.message = result.message;

            var analysis_list = new Array();

            this.query.years.forEach(function(item) {
              var amount_array = new Array(12); //固定12個月
              amount_array.fill(null); //預設填null，無資料時就不會顯示

              var analysis_item = {
                name: item,
                data: amount_array,
              };
              analysis_list.push(analysis_item);
            });

            //業務員每月銷售小計
            result.data.analysis.forEach(function(item) {
              //console.log(item, 'item')
              //console.log(analysis_list, 'analysis_list')
              const obj = analysis_list.find(
                (element) => element.name === item.year
              );
              //console.log(obj, 'obj')
              item.months.forEach(function(detail) {
                //console.log(detail, 'detail')
                obj.data[detail.month - 1] +=
                  Math.round(detail.amount * 100) / 100; //四捨五入到小數第二位
              });
            });
            this.chart_title =
              "業務員銷售分析圖-業務員：" + this.query.salesman.name;
            this.chart_sub_title = "銷售年度：" + this.query.years;
            this.series = analysis_list;
          })
          .catch(function(e) {
            console.log(e);
          });
      }
    },
  },
};
</script>
